import { initI18n as initI18Helper } from '@vp/i18n-helper';
import defaultMessagesJSON from '../../public/i18n/en-US.json';
import { getCurrentLocale } from './locale';
import { isLocalhost } from './utils';

export default function initI18n() {
  return initI18Helper({
    defaultMessages: defaultMessagesJSON,
    projectName: 'albelli',
    translationsLocale: isLocalhost() ? 'en-us' : getCurrentLocale(),
    baseURL: 'https://translations.design.vpsvc.com',
    overrides: {
      react: {
        useSuspense: false,
      },
      debug: false,
    },
  });
}
